import { mapActions } from 'vuex';

//---helpers
import { globalLoader } from '@/helpers/variables';

//---mixins
import { dynamicHead } from '@/mixins/dynamic-head.js';

//---components
import BreadcrumbsSimple from '@/components/@general/BreadcrumbsSimple/index.vue';
import ContentBlock from '@/components/custom/ContentBlock/index.vue';

export default {
  name: 'StaticPage',
  mixins: [dynamicHead],
  components: { ContentBlock, BreadcrumbsSimple },
  props: {},
  data() {
    return {
      pageData: null
    };
  },
  created() {
    this._loadContent();
  },
  mounted() {},
  watch: {
    $route: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          // this._getChecked();
        }
      }
    }
  },
  computed: {},
  methods: {
    ...mapActions({
      getPage: 'staticPages/GET_PAGE'
    }),
    async _loadContent() {
      globalLoader(true);
      let { slug } = this.$route.params;
      this.pageData = await this.getPage(slug);
      this._setMetaParams();
      this.setMeta();
      globalLoader(false);
    },
    _setMetaParams() {
      let { metaTitle, title, metaDescription, image } = this.pageData;

      if (title || metaTitle)
        this.metaParams.title = `${metaTitle ? metaTitle : title}${this.$t('seo.metaTitleGeneral')}`;
      this.metaParams.description = `${metaDescription ? metaDescription : title} ${this.$t('seo.metaDescGeneral')}`;
      if (image) this.metaParams.image = image;
    }
  }
};
